/**
 * TimeRangePicker - Date range inputs for precise range selection.
 */

import React, { useState } from 'react';
import { Box, TextField, IconButton, Tooltip, Collapse } from '@mui/material';
import { DateRange as DateRangeIcon } from '@mui/icons-material';

function TimeRangePicker({ open, onToggle }) {
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <Tooltip title="Set date range">
        <IconButton size="small" onClick={onToggle} sx={{ p: 0.5 }}>
          <DateRangeIcon sx={{ fontSize: 18, color: open ? '#23A38F' : 'text.secondary' }} />
        </IconButton>
      </Tooltip>

      <Collapse in={open} orientation="horizontal">
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
          <TextField
            type="date"
            size="small"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            InputProps={{
              sx: { fontSize: '0.7rem', height: 28, width: 120 },
            }}
            InputLabelProps={{ shrink: true }}
          />
          <Box sx={{ color: 'text.disabled', fontSize: '0.7rem' }}>to</Box>
          <TextField
            type="date"
            size="small"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            InputProps={{
              sx: { fontSize: '0.7rem', height: 28, width: 120 },
            }}
            InputLabelProps={{ shrink: true }}
          />
        </Box>
      </Collapse>
    </Box>
  );
}

export default TimeRangePicker;
